import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Routes } from 'src/shared/model/routes';
import { apiAuth } from 'src/shared/api/auth/api';
import { queryClient } from 'src/shared/api/query-provider';
import { useAuthStore } from 'src/shared/model/auth/use-auth-store';

export const useLogout = () => {
  const navigate = useNavigate();

  const onLogout = useCallback(async () => {
    try {
      await apiAuth.logout();
    } catch {
      // Локально завершаем сессию даже если backend logout недоступен.
    } finally {
      useAuthStore.getState().onClearAuthSession();
      queryClient.clear();
      navigate(Routes.AuthPhone, { replace: true });
    }
  }, [navigate]);

  return { onLogout, isTelegramEnv: false };
};
